import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Reveal from "../components/Reveal";
import { useLang, DISTRICTS } from "../lib/i18n";
import { districtPhoto } from "../lib/rajasthanPhotos";

export default function DistrictsPage() {
  const { lang } = useLang();
  return (
    <div className="max-w-7xl mx-auto px-4 py-10" data-testid="districts-page">
      <header className="mb-10">
        <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-brk">
          {lang === "hi" ? "राजस्थान" : "Rajasthan"}
        </span>
        <h1 className="font-hindi text-4xl md:text-6xl text-ink mt-1">
          {lang === "hi" ? "ज़िलों की ख़बरें" : "District News"}
        </h1>
        <span className="block gold-rule w-32 mt-4" />
        <p className="text-sm text-muted-foreground mt-3">
          {lang === "hi"
            ? "अपना ज़िला चुनें — उसकी ताज़ा ख़बरें एक जगह"
            : "Pick your district — all its latest stories in one place"}
        </p>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {DISTRICTS.map((d, i) => (
          <Reveal key={d.id} delay={Math.min(i * 0.04, 0.4)}>
            <Link
              to={`/district/${d.id}`}
              data-testid={`district-${d.id}`}
              className="group relative block overflow-hidden border-2 border-ink"
            >
              <img
                src={districtPhoto(d.id)}
                alt={lang === "hi" ? d.hi : d.en}
                loading="lazy"
                className="w-full aspect-[16/11] object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-3.5 flex items-center gap-2">
                <MapPin size={14} className="text-gold shrink-0" />
                <div>
                  <span className="block font-hindi text-lg md:text-xl text-paper leading-tight group-hover:text-gold-light transition-colors">
                    {lang === "hi" ? d.hi : d.en}
                  </span>
                  <span className="block font-mono text-[9px] uppercase tracking-[0.18em] text-gold/80">
                    {lang === "hi" ? d.en : d.hi}
                  </span>
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
